(function () {
  "use strict";
  if (window.BEProCal) return;

  var CAL_LINK = "bambu-earth-pro/discovery-call";
  var CAL_ORIGIN = "https://app.cal.com";
  var NAMESPACE = "discovery-call";

  function text(value, limit) {
    return typeof value === "string" ? value.trim().slice(0, limit) : "";
  }

  function fields(context) {
    var contact = context.contact || {};
    var first = text(contact.firstName, 100);
    var last = text(contact.lastName, 100);
    var phone = text(contact.phone || contact.mobilePhone, 40);
    var prefill = {
      name: [first, last].filter(Boolean).join(" "),
      firstName: first,
      lastName: last,
      email: text(contact.email, 254),
      attendeePhoneNumber: phone,
      "metadata[application_ref]": text(context.applicationRef, 150),
      "metadata[contact_name]": first,
      "metadata[last_name]": last,
      "metadata[phone]": phone,
      "metadata[business_timezone]": "America/New_York"
    };
    try {
      var source = new URL(context.sourcePage);
      if (source.origin === window.location.origin) {
        prefill["metadata[source_page]"] = source.origin + source.pathname;
      }
    } catch (error) {}
    // The booker handles timezone detection and lets the visitor change it.
    // Do not force the business timezone into the visitor's timeZone setting.
    Object.keys(prefill).forEach(function (key) {
      if (!prefill[key]) delete prefill[key];
    });
    return prefill;
  }

  // Cal.com's standard HTML embed loader, scoped to the supplied event link.
  function installLoader() {
    (function (C, A, L) {
      var p = function (a, ar) { a.q.push(ar); };
      var d = C.document;
      C.Cal = C.Cal || function () {
        var cal = C.Cal;
        var ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          var api = function () { p(api, arguments); };
          var namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else {
            p(cal, ar);
          }
          return;
        }
        p(cal, ar);
      };
    })(window, CAL_ORIGIN + "/embed/embed.js", "init");
    window.Cal("init", NAMESPACE, { origin: CAL_ORIGIN });
    window.Cal.config = window.Cal.config || {};
    // Forward only the explicit prefill and metadata fields below.
    window.Cal.config.forwardQueryParams = false;
  }

  function link(context) {
    var url = new URL(CAL_ORIGIN + "/" + CAL_LINK);
    var prefill = fields(context || {});
    Object.keys(prefill).forEach(function (key) { url.searchParams.set(key, prefill[key]); });
    return url.toString();
  }

  function mount(elementId, context) {
    var element = document.getElementById(elementId);
    if (!element || element.dataset.calMounted) return;
    element.dataset.calMounted = "true";
    element.style.width = "100%";
    element.style.minHeight = "680px";
    element.style.overflow = "visible";
    installLoader();
    var config = fields(context || {});
    config.layout = "month_view";
    config.useSlotsViewOnSmallScreen = "true";
    config.theme = "light";
    window.Cal.ns[NAMESPACE]("inline", {
      elementOrSelector: "#" + elementId,
      config: config,
      calLink: CAL_LINK
    });
    window.Cal.ns[NAMESPACE]("ui", {
      theme: "light",
      hideEventTypeDetails: false,
      layout: "month_view"
    });
  }

  window.BEProCal = { mount: mount, link: link };
  window.dispatchEvent(new window.CustomEvent("be-pro-cal:ready"));
})();
